import { styled, theme } from '@clickcease/cc-client-components-lib'

const {
  colors: {
    veryLightGray: { value: veryLightGray },
  },
  space: {
    '6': { value: space6 },
  },
} = theme

export const cardStyle = {
  borderRadius: space6,
  border: `1px solid ${veryLightGray}`,

  // Remove default behavior of the card
  'header + span, header': {
    display: 'none',
  },
}

export const CardTitle = styled('div', {
  margin: '0 0 $10',
  padding: '0',
  fontSize: '$lg',
  fontWeight: '$sb',
})

export const CardText = styled('div', {
  margin: '0',
  padding: '0',
  fontSize: '$md',
  fontWeight: '$r',

  variants: {
    error: {
      true: {
        color: '$error',
        lineHeight: '20px',
      },
    },
    light: {
      true: {
        fontWeight: '$l',
      },
    },
  },
})

export const CardUsageText = styled(CardText, {
  marginTop: '$2',
  marginBottom: '$4',
})

export const UsageBarWrapper = styled('div', {})

export const CardUsageSpan = styled('span', {
  marginLeft: '$2',
  cursor: 'pointer',
  textDecoration: 'underline',
})

export const CardAdditionalRateText = styled(CardText, {
  display: 'flex',
  marginBottom: '$10',
  alignItems: 'center',
  gap: '$2',
})

export const CardPaceTextWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  marginTop: '$6',
  marginBottom: '$10',
})

export const CardDivider = styled('div', {
  margin: '$10 0',
  padding: '0',
  height: '1px',
  width: '100%',
  backgroundColor: '$veryLightNeutral',
})

export const CardMonthsView = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '$10',
})

export const CardMonthsBoxWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'row-reverse',
  gap: '$8',
  justifyContent: 'space-between',
  '&:has(:only-child)': { flexDirection: 'row' },
})

export const CardMonthBox = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '$4',
})

export const CardMonthBoxTitle = styled('div', {
  fontSize: '$md',
  fontWeight: '$l',
  marginBottom: '$2',
})

export const CardMonthBoxValue = styled('div', {
  fontSize: '$h3',
  fontWeight: '$sb',
})

export const ButtonWrapperForTooltip = styled('div', {
  margin: '0',
  padding: '0',
})
